<template>
  <div class="news-detail">
    <h2>共克时艰，金票相伴！融资利率大降10%，三一助伙伴渡难关</h2>
    <p class="time">2020-03-28</p>
    <div class="content">
      <p>抗疫复工，三一在行动。在做好自身复工复产工作的同时，三一持续关注合作供应商的复产与经营状况。</p>
      <p>为缓解合作伙伴经营压力，3月16日，<a href="#/home">三一金票</a>（<a href="#/home">www.sanyjp.com</a>）宣布，将其融资年利率从5％调低至4.5％，帮助合作供应商渡过难关。</p>
      <p class="fw-bold">金票利率低10％</p>
      <div class="img-wrap">
        <img src="../assets/news_4.png" alt />
      </div>
      <p>当下，受疫情影响，广大合作供应商企业普遍面临资金困难，复工复产也受到了一定影响。</p>
      <p>为此，经与各大金融机构争取和协商，三一决定将旗下供应链服务平台——“金票”的融资利率从5％调低至4.5％，降幅10％，以助合作供应商企业进一步降低融资成本，快速回笼资金。</p>
      <p>三一重工财务总监刘华表示，“调整后，办一笔100万的融资，每年可节省5000元”。按金票全年签发200亿元测算，本次利率降低10％，相当于帮供应商每年节约融资利息约1亿元。</p>
      <p>本次调整将从今年3月16日持续至12月31日，将惠及平台旗下所有注册供应商。</p>
      <p class="fw-bold">线上服务不打烊</p>
      <p>疫情时期，三一“金票”积极运用技术手段，简化手续，优化流程，全力推广线上免接触式服务，确保服务“不打烊”。</p>
      <p>“业务全部在线上办理，审批速度非常快”，长沙今楚环保总经理刘立为介绍，他提交80万元融资申请后，当天就收到了资金到账短信。“这极大地缓解了我们现金流压力，为复工复产提供了有力的资金支持”。</p>
      <div class="img-wrap">
        <img src="../assets/news_5.png" alt />
      </div>
      <p>目前，平台以“7×24”模式响应服务，客户可通过移动端、PC端、用户社群等多种线上渠道获得在线帮助。</p>
      <p>三一集团首席财务官黄建龙表示，三一致力于打造“供应商联盟”，希望通过“金票”等平台，与上下游供应商建立“更长期、更稳定、更密切”的战略伙伴关系。</p>
      <p>据悉，三一“金票”平台于2019年12月6日正式上线，是国内行业首家专业的供应链服务平台。</p>
      <p>作为三一集团重点推广的结算工具，“金票”以数字化手段，聚焦中小企业“融资难、融资贵”痛点，备受业界好评。目前，已有100多家供应商完成有效注册。</p>
      <div class="img-wrap">
        <img src="../assets/news_6.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less">
.news-detail {
  padding: 80px 30px;
  h2 {
    color: #222;
    font-size: 42px;
  }
  .time {
    font-size: 22px;
    color: #aaa;
    margin-top: 38px;
  }
  .content {
    font-size: 26px;
    color: #808080;
    line-height: 1.6;
    p {
      margin-top: 50px;
      text-indent: 52px;
      &.below-img {
        margin-top: 0;
      }
      a {
        color: #0277D7;
      }
    }
    h3 {
      font-size: 32px;
      color: #333;
      margin-top: 50px;
    }
    .img-wrap {
      text-align: center;
      margin-top: 50px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .fw-bold {
    font-weight: bold;
  }
}
</style>
